export default "__VITE_ASSET__DM1RS400__"